import { render } from "./LinesROIModal.vue?vue&type=template&id=bffdc3c0&ts=true"
import script from "./LinesROIModal.vue?vue&type=script&lang=ts"
export * from "./LinesROIModal.vue?vue&type=script&lang=ts"

import "./LinesROIModal.vue?vue&type=style&index=0&id=bffdc3c0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__